// extracted by mini-css-extract-plugin
export default {"container":"_1jLw","header":"_3ynP","heading":"_16wO"};